import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://hackmd.io/@snakajima/HJva6n-Jj",
  class: "underline",
  target: "_blank"
}, "On-Chain Asset Store and Composer", -1)
const _hoisted_3 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.$t("keyMessage.message1")) + " " + _toDisplayString(_ctx.$t("keyMessage.message1a")) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t("keyMessage.message1b")), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("keyMessage.message2")), 1)
  ]))
}